import styled from 'styled-components';

export const TableWrapper = styled.div`
  display: grid;
  grid-template-columns: [col-campaign] auto [col-percent] min-content;
  align-items: stretch;
  font-family: 'Sofia Pro', system-ui, -apple-system, BlinkMacSystemFont, 'Avenir Next', Avenir,
    'Segoe UI', 'Lucida Grande', 'Helvetica Neue', Helvetica, 'Fira Sans', Roboto, Noto,
    'Droid Sans', Cantarell, Oxygen, Ubuntu, 'Franklin Gothic Medium', 'Century Gothic',
    'Liberation Sans', sans-serif;
  background-color: #fff;
  margin: 0 -${({ theme }) => theme.spacing.values.base} 0 -${({ theme }) =>
    theme.spacing.values.plusHalf};
`;
